<template>
  <div class="book_infor p_t">
    <TopHead :title="ydInfo.title" :closePop="true" @close="$emit('close')"></TopHead>
    <div class="bi_c">
      <!--<div class="f_title mb_20">{{ydInfo.title}}</div>-->
      <div v-html="ydInfo.contentInfo"></div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "BookInfor",
    props:{
      code:{//标题
        type:String,
        default:''
      },
    },
    data() {
      return {
        ydInfo:{},
      }
    },
    created(){
      this.queryContentByCode();
    },
    methods: {
      //查询预定须知
      queryContentByCode(){
        this.$api.queryContentByCode(this.code).then(res => {
          this.ydInfo = JSON.parse(JSON.stringify(res.data));
        })
      },
    }
  }
</script>

<style scoped lang="scss">
  .book_infor{
    position: fixed;
    width: 100%;
    height: 100vh;
    left: 0;
    top: 0;
    z-index: 999;
    background-color: white;
  }
  .bi_c{
    padding: 20px 13px;
  }

</style>
